export const IS_AT_BOTTOM_OFFSET = 10; // in pixels, offset to consider the chat is at the bottom
export const AGENT_RESPONSE_TIMEOUT = 20000; // in miliseconds
